import { render, staticRenderFns } from "./ReportStranger.vue?vue&type=template&id=8797d5f6"
import script from "./ReportStranger.vue?vue&type=script&lang=js"
export * from "./ReportStranger.vue?vue&type=script&lang=js"
import style0 from "./ReportStranger.vue?vue&type=style&index=0&id=8797d5f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports